import { render } from "./digital_form.vue?vue&type=template&id=6e774156"
import script from "./digital_form.js?vue&type=script&lang=js"
export * from "./digital_form.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__